import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import AnalyticsRevenue from "./pages/AnalyticsRevenue";
import AnalyticsTechnicianCapacity from "./pages/AnalyticsTechnicianCapacity";
import AnalyticsRouteLoad from "./pages/AnalyticsRouteLoad";
import AnalyticsMissedRecovery from "./pages/AnalyticsMissedRecovery";
import AnalyticsLeadConversion from "./pages/AnalyticsLeadConversion";
import AnalyticsClv from "./pages/AnalyticsClv";
import AnalyticsMarketing from "./pages/AnalyticsMarketing";
import PestAnalyticsOverview from "./pages/PestAnalyticsOverview";
import OwnerScorecard from "./scorecard/OwnerScorecard";
import { getIndustryKey } from "../../constants/uiRegistry";

export default function AnalyticsRouter() {
  // Events has no technicians or routes — the drill-down pages are pest/dispatch
  // surfaces (Technician Capacity, Route Load). Gate them: an events tenant who
  // lands on /analytics/technicians or /analytics/routes (old link, typed URL)
  // is sent back to the dashboard rather than shown a dispatch page.
  const isEvents = getIndustryKey() === "events";

  return (
    <Routes>
      {/* Pest gets the single operator landing page; events/landscaping keep
          their existing gated AnalyticsDashboard views. Drill-downs below stay
          reachable (the landing tiles link to them). */}
      <Route index element={getIndustryKey() === "pest_control" ? <PestAnalyticsOverview /> : <AnalyticsDashboard />} />
      <Route path="revenue" element={<AnalyticsRevenue />} />
      <Route
        path="technicians"
        element={isEvents ? <Navigate to="/analytics" replace /> : <AnalyticsTechnicianCapacity />}
      />
      <Route
        path="routes"
        element={isEvents ? <Navigate to="/analytics" replace /> : <AnalyticsRouteLoad />}
      />
      <Route path="recovery" element={<AnalyticsMissedRecovery />} />
      <Route path="lead-conversion" element={<AnalyticsLeadConversion />} />
      <Route path="clv" element={<AnalyticsClv />} />
      <Route path="marketing" element={<AnalyticsMarketing />} />
      {/* Tenant-gated by the backend: a tenant it is not on for gets a "not turned on" notice. */}
      <Route path="scorecard" element={<OwnerScorecard />} />

      {/* Back-compat aliases from older nav configs */}
      <Route path="conversion" element={<Navigate to="/analytics/lead-conversion" replace />} />
      <Route path="revenue/*" element={<Navigate to="/analytics/revenue" replace />} />
      <Route path="*" element={<Navigate to="/analytics" replace />} />
    </Routes>
  );
}

